<template>
  <MasterDetail
    ref="masterDetail"
    :confirmDeleteMessage="confirmDeleteMessage"
    :cols="cols"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :resourceUrl="resourceUrl"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {}
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      return [
        {
          key: "nome",
          name: "Divisão",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        }
      ];
    },
    resourceUrl() {
      return `/v1/ativacaoped/${this.clientId}/business-units-divisao`;
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
      }
    }
  },
  methods: {
    confirmDeleteMessage({ nome }) {
      return `Deseja excluir a divisão ${nome}?`;
    },
    goToHome() {
      this.notify({
        error: 'Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada.',
      });
      this.$router.push({ name: "homepage" });
    },
  }
};
</script>
